import React, { useEffect, useState } from "react";
import { Col, Divider, Drawer, Menu, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { css, keyframes } from "@emotion/css";
import SearchBar from "./searchbar";
import { TranslatorNavigationTag } from "../../languageTranslator/LanguageTranslatorTags";
import { toggleDrawerAction } from "../../store/action/admin/themeActions";
import { menuItems } from "./HeaderDrawerDataList";

const { Title, Text } = Typography;

const sidebarDrawerMenu = css`
  // margin-top: 20px;
  padding: 30px 20px 20px 20px;
`;

const sidebarDrawer1 = css`
  position: sticky;
  top: 0;
  left: 0;
  z-index: 998;
`;

function DrawerHeaderListView({
  current,
  handleClick,
  isMenuItem,
  isVisible,
  onCancel,
}) {
  const dispatch = useDispatch();
  const themeDefault = useSelector((state) => state.themeDefault);
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;

  const newMenuItems = menuItems(sharedUserInfo);
  const sidebarDrawer = css`
    .ant-menu .ant-menu-item,
    .ant-menu .ant-menu-submenu,
    .ant-menu .ant-menu-submenu-title {
      border-radius: 0px !important;
    }
    z-index: ${isVisible ? "1" : "0"};
    height: 100%;
    width: 100%;
    position: ${isVisible ? "fixed" : ""};
    backdrop-filter: blur(
      ${isVisible ? themeDefault?.info?.newConfig?.drawerbackDropBlur : ""}
    );
    left: 0;
    background-color: ${isVisible ? "rgb(0 0 0 / 14%)" : ""};
    transition: color 0.1s ease, background-color 0.6s ease-in-out,
      border 0.3s ease-in-out;
    .ant-menu-inline .ant-menu-item {
      height: clamp(20px, 2vw, 30px) !important;
    }
    .ant-menu-inline .ant-menu-item,
    .ant-menu-vertical .ant-menu-item,
    .ant-menu-inline .ant-menu-submenu-title,
    .ant-menu-vertical .ant-menu-submenu-title {
      margin-block: 0px;
    }
    .ant-menu-light:not(.ant-menu-horizontal)
      .ant-menu-item:not(.ant-menu-item-selected):hover,
    .ant-menu-light
      > .ant-menu:not(.ant-menu-horizontal)
      .ant-menu-item:not(.ant-menu-item-selected):hover {
      background-color: rgb(255 255 255 / 0%);
    }
  `;
  const sidebarDrawerMenuItem = (item2) => css`
    transition: color 0.3s ease-in-out, background-color 0.6s ease-in-out,
      border 0.3s ease-in-out;
    padding: 0px 15px;
    margin: 12px 0px;
    height: 25px;
    display: flex;
    width: 100%;
    height: 35px;
    color: ${themeDefault?.info?.newConfig?.color};
    &:hover {
      .ant-typography {
        color: ${themeDefault?.info?.colorPrimary} !important;
      }
      // border-bottom: 1px solid ${themeDefault?.info?.colorPrimary};
    }

    .ant-typography {
      color: ${current === item2?.key
        ? `${themeDefault?.info?.colorPrimary}`
        : `${themeDefault?.info?.newConfig?.color}`} !important;
      border-bottom: ${current === item2?.key
        ? `2px solid ${themeDefault?.info?.colorPrimary}`
        : "2px solid transparent"};
    }

    :where(.css-dev-only-do-not-override-mg9lgc).ant-menu-inline
      .ant-menu-item {
      line-height: 0px !important;
    }
  `;
  return (
    <div className={sidebarDrawer1}>
      <div className={sidebarDrawer}>
        <div
          id="drawer"
          className={css`
            // display: ${isVisible ? "block" : "none"};
            position: absolute;
            left: 0;
            right: 0;
            z-index: 1000;
            transition: display 0.3s ease-in-out, top 0.3s ease-in-out;
            top: ${isVisible ? "clamp(30px, 2.5vw, 50px)" : "-500px"};
          `}
        >
          <Menu
            // theme="dark"
            mode="inline"
            // defaultSelectedKeys={['1']}
            className={sidebarDrawerMenu}
            selectedKeys={[current]}
            onClick={handleClick}
          >
            <div
              className={css`
                display: flex;
                justify-content: center;
                width: 100%;
              `}
            >
              {newMenuItems.map((item, _index) =>
                item.show === true && item.category === isMenuItem ? (
                  item.category === "AI" ? (
                    <SearchBar fromDrawer onCancel={onCancel} />
                  ) : (
                    <>
                      {item?.children && item?.children?.length > 0 ? (
                        <>
                          <Row
                            gutter={[0, 4]}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Col>
                              <Title
                                level={5}
                                className={css`
                                  font-weight: 700 !important;
                                `}
                                style={{
                                  fontSize:
                                    themeDefault?.info?.newConfig
                                      ?.paraSecondaryFontSize,
                                  textTransform: "uppercase",
                                  padding: "4px 15px",
                                }}
                              >
                                <TranslatorNavigationTag>
                                  {item?.label}
                                </TranslatorNavigationTag>
                              </Title>
                              <hr
                                style={{
                                  marginInline: "8px",
                                  marginBlock: "8px",
                                  marginBottom: "4px",
                                  border: "0px",
                                  borderTop: `1px solid ${themeDefault?.info?.colorPrimary}`,
                                }}
                              />
                            </Col>

                            {item?.children.map(
                              (item2) =>
                                item2.show === true && (
                                  <Col key={item2?.key}>
                                    <Menu.Item
                                      key={item2?.key}
                                      className={sidebarDrawerMenuItem(item2)}
                                    >
                                      {Array.isArray(item2?.label) ? (
                                        <div style={{ margin: "0px 10px" }}>
                                          <Link
                                            to={item2?.link[0]}
                                            onClick={() =>
                                              dispatch(
                                                toggleDrawerAction(false)
                                              )
                                            }
                                          >
                                            <Text>
                                              <TranslatorNavigationTag>
                                                {item2?.label[0]}
                                              </TranslatorNavigationTag>
                                            </Text>
                                          </Link>
                                          <hr />
                                          <Link
                                            to={item2?.link[1]}
                                            onClick={() =>
                                              dispatch(
                                                toggleDrawerAction(false)
                                              )
                                            }
                                          >
                                            <Text>
                                              <TranslatorNavigationTag>
                                                {item2?.label[1]}
                                              </TranslatorNavigationTag>
                                            </Text>
                                          </Link>
                                        </div>
                                      ) : (
                                        <div style={{ margin: "0px 10px" }}>
                                          <Link
                                            to={item2?.link}
                                            onClick={() =>
                                              dispatch(
                                                toggleDrawerAction(false)
                                              )
                                            }
                                          >
                                            <Text>
                                              <TranslatorNavigationTag>
                                                {item2?.label}
                                              </TranslatorNavigationTag>
                                            </Text>
                                          </Link>
                                        </div>
                                      )}
                                    </Menu.Item>
                                  </Col>
                                )
                            )}
                          </Row>
                        </>
                      ) : (
                        <>
                          <Menu.Item
                            key={item.key}
                            className={sidebarDrawerMenuItem}
                          >
                            {/* Check if the label is an array and render accordingly */}
                            {Array.isArray(item?.label) ? (
                              <div style={{ margin: "0px 10px" }}>
                                <Link
                                  to={item?.link[0]}
                                  onClick={() =>
                                    dispatch(toggleDrawerAction(false))
                                  }
                                >
                                  <Text>
                                    <TranslatorNavigationTag>
                                      {item?.label[0]}
                                    </TranslatorNavigationTag>
                                  </Text>
                                </Link>
                                <hr />
                                <Link
                                  to={item?.link[1]}
                                  onClick={() =>
                                    dispatch(toggleDrawerAction(false))
                                  }
                                >
                                  <Text>
                                    <TranslatorNavigationTag>
                                      {item?.label[1]}
                                    </TranslatorNavigationTag>
                                  </Text>
                                </Link>
                              </div>
                            ) : (
                              <div style={{ margin: "0px 10px" }}>
                                <Link
                                  to={item?.link}
                                  onClick={() =>
                                    dispatch(toggleDrawerAction(false))
                                  }
                                >
                                  <Text>
                                    <TranslatorNavigationTag>
                                      {item?.label}
                                    </TranslatorNavigationTag>
                                  </Text>
                                </Link>
                              </div>
                            )}
                          </Menu.Item>
                        </>
                      )}
                    </>
                  )
                ) : (
                  <></>
                )
              )}
            </div>
          </Menu>
        </div>
      </div>
    </div>
  );
}

export default DrawerHeaderListView;
